import http from '../../Services/Auth/config/http-common'
import DTOViajes from '../../DTOs/Operaciones/DTOViajes'
import IRespuesta from '../../Interfaces/Respuestas/IRespuesta'
import DTOViajesServicios from '../../DTOs/Operaciones/DTOViajesServicios'
import DTOUltimaCaja from '../../DTOs/Operaciones/DTOUltimaCaja'
import DTOViajeEstatusSecuencia from '../../DTOs/Operaciones/DTOViajeEstatusSecuencia'
import DTOChangeTripStatus from '../../DTOs/Operaciones/DTOChangeTripStatus'
import DTOResultTripStatus from '../../DTOs/Operaciones/DTOResultTripStatus'

class OpViajesDataService {
  async Get() {
    return await http.get<DTOViajes[]>('Operaciones/OpViajes/Get')
  }
  async GetAllServices(Status: number) {
    return await http.get<DTOViajesServicios[]>(
      `Operaciones/OpViajes/GetAllServices?Status=${Status}`
    )
  }
  async GetLastTrailerBox(idViaje: number) {
    return await http.get<DTOUltimaCaja>(
      `Operaciones/OpViajes/GetLastTrailerBox?idViaje=${idViaje}`
    )
  }
  async GetStatusSecuence() {
    return await http.get<DTOViajeEstatusSecuencia[]>(
      `Operaciones/OpViajes/GetStatusSecuence`
    )
  }
  async ChangeTripStatus(data: DTOChangeTripStatus) {
    return await http.put<DTOResultTripStatus>(
      `Operaciones/OpViajes/ChangeTripStatus/${data.idViaje}`,
      data
    )
  }
  async Append(data: DTOViajes) {
    return await http.post<DTOViajes>(`Operaciones/OpViajes/Append`, data)
  }
  async AppendServices(data: DTOViajesServicios) {
    return await http.post<DTOViajesServicios[]>(
      `Operaciones/OpViajes/AppendService`,
      data
    )
  }
  async Delete(id: number) {
    return await http.delete<IRespuesta>(`Operaciones/OpViajes/Delete/${id}`)
  }
  async DeleteService(id: number) {
    return await http.delete<IRespuesta>(
      `Operaciones/OpViajes/DeleteService/${id}`
    )
  }
}
export default new OpViajesDataService()
